<p class="headtext">Are you sure you want to delete the selected box (<b>{{deletedBoxComponentName}}</b>) ?</p>
<div class="buttonLIst">
    <button mat-flat-button color="secondary" mat-dialog-close >Cancel</button>
    <button mat-flat-button color="warn" [mat-dialog-close] = "deleted">
        <span> <img src="../../../assets/images/done.svg" /></span>
        Delete Box</button>
</div>
 